<template>
  <div>
         <stepheader :step="step"/>
        <div id="wizard2-p-0" role="tabpanel" aria-labelledby="wizard2-h-0" class="body current" aria-hidden="false" style="">
          <div class="row">
                  <div class="col-md-6">
           <label class="form-label" for="telefono">Nome:</label>
              <input type="text" id="telefono"  v-model="entity.nome" class="form-control "/>
            </div>
                  <div class="col-md-6">
           <label class="form-label" for="telefono">Cognome:</label>
              <input type="text" id="telefono"  v-model="entity.cognome" class="form-control "/>
            </div>
           <div class="col-md-6">
           <label class="form-label" for="telefono">Telefono:</label>
              <input type="text" id="telefono"  v-model="entity.telefono" class="form-control "/>
            </div>
             <div class="col-md-6">
           <label class="form-label" for="email">Email:</label>
              <input type="text" id="email"  v-model="entity.email" class="form-control "/>
            </div>
             <div class="col-md-3">
           <label class="form-label" for="marca">Marca Device:</label>
              <input type="text" id="marca"  v-model="entity.marca" class="form-control "/>
            </div>
             <div class="col-md-3">
           <label class="form-label" for="marca">Modello:</label>
              <input type="text" id="marca"  v-model="entity.modello" class="form-control "/>
            </div>

            <div class="col-md-3">
           <label class="form-label" for="memoria">Memoria:</label>
              <input type="text" id="memoria"  v-model="entity.memoria" class="form-control "/>
            </div>
              <div class="col-md-3">
           <label class="form-label" for="colore">Colore:</label>
              <input type="text" id="colore"  v-model="entity.colore" class="form-control "/>
            </div>
              <div class="col-12">
           <label class="form-label" for="colore">Messaggio:</label>
              <textarea id="messaggio"  v-model="entity.messaggio" class="form-control"></textarea>
            </div>
          </div>
   
          <buttons :buttons=step.buttons v-on:action="fireaction"></buttons>
											
 
  </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import axios from "axios";
export default {
  name: "errordevice",

  props: {
    step: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  ticket: {
      type: Object,
      required: false,
    },
    code: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
     entity:{ nome:"",cognome:"",email:"",telefono:"", marca:"", modello:"", memoria:"", colore:"", messaggio:""}
    };
  },
  computed: {
   
  },
  components: {
   
  },
  mounted() {
     
  },
  methods: {
    fireaction:function(action,nextstep){
      switch(action){
        case "next":
           var validPhoneRegex = /^[0-9]{1,}$/;
           if(!this.entity.email.match(/(?:[a-z0-9+!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gi)){
         swal({
              title: "Errore di compilazione",
              text: "Inserire un'indirizzo email valido",
              type: "error",
              showCancelButton: false,
              toast: false,
               timer: 2000, 
              showConfirmButton: false,
              position: "bottom-top",
            });

           }else if(!this.entity.telefono.match(validPhoneRegex)){
         swal({
              title: "Errore di compilazione",
              text: "Inserire un numero di telefono valido",
              type: "error",
              showCancelButton: false,
              toast: false,
               timer: 2000, 
              showConfirmButton: false,
              position: "bottom-top",
            });

           }
           else{
var newthread = {
        oggetto: "a",
        note: "",
        idTicket: 0,
        attachments: []
      };
      newthread.oggetto="Errore devices";
      newthread.note =`
      <p>
        I dati in nostro possesso del device con IMEI/Seriale <strong>${this.ticket.device.identificativoDevice}</strong> sono i seguenti: <br/>
        modello ${this.ticket.device.brand.brand} ${this.ticket.device.modello.modello} 
        memoria ${this.ticket.device.memoria.memoria}
        <br/>
      <strong>Nome :</strong> ${this.entity.nome}<br/>
      <strong>Cognome:</strong> ${this.entity.cognome}<br/>
      <strong>Telefono:</strong> ${this.entity.telefono}<br/>
      <strong>Email:</strong> ${this.entity.email}<br/>
      <strong>Marca:</strong> ${this.entity.marca}<br/>
      <strong>Modello:</strong> ${this.entity.modello}<br/>
      <strong>Memoria:</strong> ${this.entity.memoria}<br/>
      <strong>Messaggio: 
      
     </p>
      ${this.entity.messaggio}

      `;
      axios.post("ticketcomunicazioni/thread", {
        thread: newthread, attachments: [],
        tipologia: 'cliente'
      }).then((response) => {
       
        this.$emit("goto",nextstep);
      })
    }


  //this.$emit("goto",nextstep);

        
          break;
default:
   this.$emit("goto",nextstep);
  break;
      }

    },
   loaddata: function () {
    
    },

    authenticate:function(nextstep){

    }
  },
};
</script>